<div>
  
  <div class="ml-4 print-all-content" *ngIf="outcome" [ngClass]="IsGlossary?'mt-2':'mt-6'">

    <div class="mb-2 paraHeader">
      <div class="padding-content-screen" id="tableOfContents">
        <div class="flex-display ml-72 mt-1">
          <div class="h-20px highlight-blue border-bottom-help cursor-pointer" (click)="OpenWhatLinksHere()" (keyup.enter)="OpenWhatLinksHere()" tabindex="0">
            <img src="../../../../assets/icons/Link.svg" class="whatsNew-image image-info" alt="What links here" />What Links Here
          </div>
        </div>
      </div>
      <div><app-breadcrumbs-path [crumbData]="navData.crumbData"></app-breadcrumbs-path></div>
      <span class="generalHeader">{{dataSource.data[0].item}}</span>
    </div>
    <div class="mt-2 mb-2">
      <div class="paraHeader mb-1">Table of Contents</div>
      <div *ngIf="dataSource.data[0].itemLink == null"><span class="highlight-blue border-bottom-help cursor-pointer singleLine mt-1rem" (click)="JoinAllSubtopics()" (keyup.enter)="JoinAllSubtopics()" tabindex="0"> Show All in One Page </span></div>
      <div *ngIf="dataSource.data[0].itemLink == null" class="mt-1rem"><span class="highlight-blue border-bottom-help cursor-pointer singleLine mt-1rem" (click)="JoinAllSubtopicsIncludingSharedSubtopics()" (keyup.enter)="JoinAllSubtopicsIncludingSharedSubtopics()" tabindex="0"> Show All in One Page <span class="font-14">(including Shared Subtopics)</span></span></div>
      <div *ngIf="dataSource.data[0].itemLink == null" class="flex-display">
        <div class="highlight-blue border-bottom-help cursor-pointer singleLine mt-1rem" (click)="tree.treeControl.collapseAll()" (keyup.enter)="tree.treeControl.collapseAll()" tabindex="0"> Collapse</div>
        <div class="mt-1rem">&nbsp;&nbsp;|&nbsp;&nbsp;</div>
        <div class="highlight-blue border-bottom-help cursor-pointer singleLine mt-1rem" (click)="tree.treeControl.expandAll()" (keyup.enter)="tree.treeControl.expandAll()" tabindex="0"> Expand </div>
      </div>
    </div>
    <mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
      <!-- This is the tree node template for leaf nodes -->
      <!-- There is inline padding applied to this node using styles.
        This padding value depends on the mat-icon-button width. -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
        <span class="font-16" *ngIf="node.itemLink == null">{{node.item}}</span>
        <span class="highlight-blue border-bottom-help cursor-pointer singleLine" *ngIf="node.itemLink != null" (click)="navigateToUrl(node.itemLink)">{{node.item}}</span>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <div class="mt-1rem mb-1 font-18 itcHeavyFont" *ngIf="node.isIndustryChanged">Shared Subtopics</div>
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.item">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <!-- Start -- Hyperlink Topic and Subtopic FPP-38 -->
          <span class="font-16 highlight-blue border-bottom-help cursor-pointer singleLine" *ngIf="node.itemLink == null" (click)="navigateToUrlSubTopics(node)">{{node.item}}</span>
          <!-- End -- Hyperlink Topic and Subtopic FPP-38 -->
        </div>
        <!-- There is inline padding applied to this div using styles.
        This padding value depends on the mat-icon-button width.  -->
        <div [class.example-tree-invisible]="!treeControl.isExpanded(node)"
             role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>

</div>
